import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { catchError, of, take } from 'rxjs';
import { DocksModel } from 'src/app/models/DocksModel';
import { ChassisService } from 'src/app/services/chassis/chassis.service';

@Component({
  selector: 'app-view-chassis',
  templateUrl: './view-chassis.component.html',
  styleUrls: ['./view-chassis.component.css']
})
export class ViewChassisComponent {


  constructor(private readonly router: Router,
    private readonly chassisService: ChassisService) { }

  config: boolean = false;
  dateInterval: any
  updateInterval: any
  chassisDocks: DocksModel[] = []
  dockId!: number
  selectedDock: number | any
  faFilter = faFilter

  ngOnInit() {
    this.updateData();

    this.dateInterval = setInterval(() => {
      this.updateData();
    }, 5000);
  }

  updateData(): void {
    this.chassisService.getChassisDocksDataView().pipe
      (take(1),
        catchError(() => {
          return of([])
        })
      ).subscribe(
        (response) => {
          this.chassisDocks = response.map(d => ({
            ...d,
            status: new Date(d.status + 'Z')
          }));
        }
      )
  }


  changeDockPage() {
    if (this.selectedDock !== null) {
      this.config = false;
      this.router.navigate([`/view/chassis/dock/${this.selectedDock}`]);
    }
  }
}
